export enum EntityTypeEnum {
  None = 'None',
  Shipment = 'Shipment',
  Stop = 'Stop'
}
